<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->

        <!-- <h2 class="brand-text text-primary ml-1">
          Plataforma CMA
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
        v-if="showForm"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
        <div class="logo-login">
            <span class="logo-cma-pwd"></span>
          </div>
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('FORGOTPWD.Title')}}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('FORGOTPWD.Description') }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    ref="userEmail"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="Digite o email"
                  />
                  <small class="text-danger" v-if="showValidationErrors">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
              >
                {{ $t('FORGOTPWD.Recover') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login-v2'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('BUTTONS.Back') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->

      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
          v-else
      >

        <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
        >
          <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
          >
            {{ $t('FORGOTPWD.Email_Sent_Title') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('FORGOTPWD.Email_Sent') }}
            
          </b-card-text>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login-v2'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('BUTTONS.Back') }}
            </b-link>
          </p>
        </b-col>

      </b-col>

<!--      <div class="p-8" v-else>-->
<!--        <div class="vx-card__title mb-8">-->
<!--          <h4 class="mb-">E-mail enviado</h4>-->
<!--          <p>Um e-mail foi enviado para você. Por favor, verifique a sua caixa de entrada</p>-->
<!--        </div>-->
<!--        <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-5">-->
<!--          <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">-->
<!--            Voltar-->
<!--          </vs-button>-->
<!--        </div>-->
<!--      </div>-->

    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import userService from '../../providers/userService'
import AppConstants from '@/appConstants'

export default {
  components: {
    // VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      email,
      showForm: true,
      showValidationErrors: false,
    }
  },
  mounted() {
    const emailStore = this.getEmailFromStore();
    if (emailStore) {
      this.userEmail = emailStore;
    }
    this.$refs["userEmail"].focus();
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === AppConstants.THEME_DARK) {
        /* eslint-disable */
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    getEmailFromStore() {
      return localStorage.email;
    },
    sendEmail() {
      userService.forgotPassword({email: this.userEmail}, new URLSearchParams())
          .then(() => {
            this.showForm = false;
          }).catch(error => console.log(error));
    },
    validationForm() {
      this.showValidationErrors = true;
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
         this.sendEmail();
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
